import { Store, Module, ActionContext } from 'vuex';
import ListModule from './list-module';
import ListState from './list-state';
import AirlineCompany from '../entities/flight/airlineCompany';

import Ajax from '../../lib/ajax';
import PageResult from '@/store/entities/page-result';
import ListMutations from './list-mutations';

interface AirlineCompanyState extends ListState<AirlineCompany> {
  airlineCompany: AirlineCompany;
  editAirlineCompany: AirlineCompany;
}

class AirlineCompanyMutations extends ListMutations<AirlineCompany> {}

class AirlineCompanyModule extends ListModule<
  AirlineCompanyState,
  any,
  AirlineCompany
> {
  state = {
    totalCount: 0,
    currentPage: 1,
    pageSize: 10,
    list: new Array<AirlineCompany>(),
    loading: false,
    editAirlineCompany: new AirlineCompany(),
    selectAirlineCompany: new AirlineCompany(),
  };
  actions = {
    async selectAirlineCompany(
      context: ActionContext<AirlineCompanyState, any>,
      payload: any
    ) {
      context.state.editAirlineCompany = payload.data;
    },

    async saveAirlineCompany(
      context: ActionContext<AirlineCompanyState, any>,
      payload: any
    ) {
      let reponse = await Ajax.post(
        '/api/services/app/Flight/SaveAirlineCompany',
        payload.data
      );

      let page = reponse.data.result as PageResult<AirlineCompany>;
      context.state.totalCount = page.totalCount;
      context.state.list = page.items;
    },
    async updateAirlineCompany(
      context: ActionContext<AirlineCompanyState, any>,
      payload: any
    ) {
      let reponse = await Ajax.put(
        '/api/services/app/Flight/UpdateAirlineCompany',
        payload.data
      );

      let page = reponse.data.result as PageResult<AirlineCompany>;
      context.state.totalCount = page.totalCount;
      context.state.list = page.items;
    },
    async getAirlineCompanies(
      context: ActionContext<AirlineCompanyState, any>,
      payload: any
    ) {
      // context.state.loading=true;
      let reponse = await Ajax.get(
        '/api/services/app/Flight/GetAirlineCompanies',
        payload.data
      );

      // context.state.loading=false;
      let page = reponse.data.result as PageResult<AirlineCompany>;
      context.state.totalCount = page.totalCount;
      context.state.list = page.items;
    },
    async deleteAirlineCompany(
      context: ActionContext<AirlineCompanyState, any>,
      payload: any
    ) {
      await Ajax.delete(
        '/api/services/app/Flight/DeleteAirlineCompany?input=' + payload.payload
      );
    },
  };
  mutations = {
    setCurrentPage(state: AirlineCompanyState, page: number) {
      state.currentPage = page;
    },
    setPageSize(state: AirlineCompanyState, pagesize: number) {
      state.pageSize = pagesize;
    },
  };
}
const airlineCompanyModule = new AirlineCompanyModule();
export default airlineCompanyModule;
